import "./SnapWidgetAccountDeletion.css";

export default function AudioSplitDeletionRequest() {
  const subject = encodeURIComponent("AudioSplit account deletion request");
  const body = encodeURIComponent("Please delete my AudioSplit account and associated data.\n\nEmail associated with my account: \nAdditional information: ");
  const requestLink = `mailto:support@blackdoorapps.com?subject=${subject}&body=${body}`;

  return (
    <main className="account-delete-page">
      <section className="account-delete-shell">
        <a className="account-delete-brand" href="/">BlackDoor</a>
        <div className="account-delete-grid">
          <div className="account-delete-copy">
            <p className="account-delete-kicker">AudioSplit</p>
            <h1>Delete my account</h1>
            <p>Request deletion of your AudioSplit account and its associated demix jobs, source media, generated stems, and account data.</p>
            <p>Requests are handled by <a href="mailto:support@blackdoorapps.com">support@blackdoorapps.com</a>. We may contact you to verify account ownership.</p>
            <p>Once verified, we will delete the requested data unless retention is required for security, legal compliance, fraud prevention, or an active dispute.</p>
            <a className="stem-delete-action" href={requestLink}>Create deletion request</a>
          </div>
        </div>
      </section>
    </main>
  );
}
